import React from 'react';
import DirectDebitForm from '@ui-components/direct-debit/form/index';
import DirectDebitSuccess from '@ui-components/direct-debit/success/index';
import formatAmount from '@utils/amount-formatter';
import { validateDirectDebit } from './validators';
import jump from 'jump.js';
import { createDirectDebit } from '@services/direct-debit';
import { API_ERRORS, DOCUMENT_TYPES, ACCOUNT_TYPES, BANKS } from '@constants';
import { fields } from './directdebit-fields'
import './main.scss';

export default class DirectDebitContainer extends React.Component<any, any> {
  sended: boolean;
    constructor(props) {
        super(props);
        this.sended = false;

        const { country } = this.props;

        const fields_filter = (country == 'CO') ? 'CO' : 'AR';

        this.state = {
            fields: fields[fields_filter],
            errors: {}
        };
        
    }    

    handleSubmit(fields) {
        
        this.sended = true;
        const errors = validateDirectDebit(fields);
        
        /*Form validations*/
        if (Object.keys(errors).length > 0) {
            return this.setState({
                errors: Object.assign({}, this.state.errors, errors)
            });
            
        }
        /*Conditions validations*/
        if (!fields.conditions) {
            return this.setState({ errorMessage: 'Debes aceptar los términos y condiciones  para continuar' }, () => {
                jump('#root', {
                    duration: 200
                });
            });
        }

        const document_error = {
            AR:{
                cuit: 'El cuilt/cuil ingresado no es válido'
            },
            CO:{
                document_number: 'El número de documento ingresado no es válido'
            }
        }
        
        
        /*Send Request*/
        this.setState(
            {
                sending: true
            },
            () => {
                createDirectDebit(fields)
                    .then(() => {
                        this.setState({
                            success: true
                        });
                    })
                    .catch(error => {

                        if (error.response.data) {
                            const errorCode = error.response.data.code;

                            /*Server validations*/
                            if (errorCode === API_ERRORS.INVALID_DOCUMENT) {
                                
                                return this.setState({
                                    errors: Object.assign({}, this.state.errors, document_error[this.props.country]),
                                    sending: false
                                });
                            
                            }

                            if (errorCode === API_ERRORS.INVALID_CBU) {
                                return this.setState({
                                    errors: Object.assign({}, this.state.errors, {
                                        cbu: 'El cbu ingresado no es válido'
                                    }),
                                    sending: false
                                });
                            }
                        }
                    });
            }
        );
    }

    handleChange(fields) {
        const valid = validateDirectDebit(fields);

        const formattedFields = {
            ...fields,
            amount: formatAmount(fields.amount)
        };

        this.setState({
            errors: valid,
            fields: formattedFields
        });
    }

    render() {
        const { country } = this.props;
        const { errors, fields, sending, success, errorMessage } = this.state;
        return (
            <div>
                {success && <DirectDebitSuccess 
                        country={country}
                        banks={BANKS[country]}
                        docTypes={DOCUMENT_TYPES[country]}
                        account_types={ACCOUNT_TYPES[country]}
                        fields={fields} />}
                {!success && (
                    <DirectDebitForm 
                        docTypes={DOCUMENT_TYPES[country]}
                        account_types={ACCOUNT_TYPES[country]}
                        banks={BANKS[country]}
                        country={country}
                        errorMessage={errorMessage}
                        showValidations={this.sended}
                        sending={sending}
                        errors={errors}
                        fields={fields}
                        onChange={fields => this.handleChange(fields)}
                        onSubmit={fields => this.handleSubmit(fields)} />
                )}
            </div>
        );
    }
}
